// extracted by mini-css-extract-plugin
export default {"form":"CustomerProfile_form__J+i6W","actions":"CustomerProfile_actions__VOvO4"};